import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { MFAConfig } from '../../dto';

type Results = { mfaConfig: MFAConfig };

export const useMFAConfig = (options?: QueryHookOptions<Results>) => {
  const query = gql`
    query mfaConfig {
      mfaConfig {
        emailOTP
        smsOTP
        totp
        passkey
        smsOtpEnabled
        totpEnabled
        passkeyEnabled
        enabled
      }
    }
  `;

  return useQuery(query, options);
};

export default useMFAConfig;
